import type { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { Footer } from 'src/shared/components/Footer'
import { PageContainer } from 'src/shared/components/PageContainer'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const POLICY_NAV = [
  {
    to: paths.termsOfService,
    en: 'Terms of service',
    sv: 'Användarvillkor',
  },
  {
    to: paths.privacyPolicy,
    en: 'Privacy policy',
    sv: 'Integritetspolicy',
  },
  {
    to: paths.cookieConsent,
    en: 'Cookie policy',
    sv: 'Cookiepolicy',
  },
] as const

export const PolicyPage = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => {
  const { t } = useLocalization()
  const { pathname } = useLocation()

  return (
    <Column className="relative">
      <PageContainer className="py-12 md:py-16">
        <Column className="mx-auto w-full max-w-3xl gap-10">
          <Column className="gap-5">
            <Row className="flex-wrap gap-x-5 gap-y-2">
              {POLICY_NAV.map((item) => {
                const isActive = pathname === item.to
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    className={cn(
                      'text-sm transition-colors',
                      isActive
                        ? 'text-slate-800'
                        : 'text-slate-400 hover:text-slate-800'
                    )}
                  >
                    {t(item.en, item.sv)}
                  </Link>
                )
              })}
            </Row>
            <Column className="gap-2">
              <h1>{title}</h1>
              <p>
                {t(
                  'Last updated 19 August 2026',
                  'Senast uppdaterad 19 augusti 2026'
                )}
              </p>
            </Column>
          </Column>

          <Column className="gap-8 [&_a]:underline [&_a]:underline-offset-2 [&_ol]:list-decimal [&_ol]:space-y-2 [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5">
            {children}
          </Column>
        </Column>
      </PageContainer>
      <Footer />
    </Column>
  )
}

export const PolicySection = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => (
  <section>
    <Column className="gap-3">
      <h2>{title}</h2>
      {children}
    </Column>
  </section>
)
